import { ThtmlSource } from '../../../../types/Tfeeds'
import { TreaderConfigGenericJson, TreaderConfigGenericXml } from '../../../../types/readerConfig'
import GenericJson from './GenericJson'
import GenericXml from './GenericXml'

interface Iprops {
  initialValues: TreaderConfigGenericXml | TreaderConfigGenericJson
  reader: string
  htmlSource: ThtmlSource
}

const ReaderConfig: React.FC<Iprops> = ({ initialValues, reader, htmlSource }) => {
  return (
    <div className='ReaderConfig'>
      {reader === 'generic-json' && (
        <GenericJson initialValues={initialValues as TreaderConfigGenericJson} htmlSource={htmlSource} />
      )}
      {reader === 'generic-xml' && (
        <GenericXml initialValues={initialValues as TreaderConfigGenericXml} htmlSource={htmlSource} />
      )}
      {reader === 'onlyjobs' && (
        <GenericXml initialValues={initialValues as TreaderConfigGenericXml} htmlSource={htmlSource} />
      )}
    </div>
  )
}

export default ReaderConfig
